import styled from 'styled-components';

import Button from '~/src/common/components/Button';
import FInputContainer from '~/src/common/components/Form/InputContainer/InputContainer';

export const Container = styled.div`
  position: absolute;
  z-index: 1;
  overflow: hidden;

  & > div,
  & > span,
  p {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;

    ::before {
      font-size: 24px; /* icone */
      line-height: 24px;
      align-self: center;
    }
  }
  width: 100%;
  margin-top: 8px;

  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.BLACK_15};
  background-color: ${({ theme }) => theme.palette.common.WHITE};

  & > div > span {
    font-size: 14px;
    font-weight: 400;
  }
`;

export const Title = styled.p`
  span {
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
  }
`;
export const ContainerRow = styled.div`
  padding: 16px;
`;

export const ContainerButtonRow = styled.div`
  padding: 7px 16px;
`;

export const CollectShopsButton = styled(Button)`
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  height: 42px;

  & > div {
    line-height: 24px;
    justify-content: space-between;
    flex-grow: 1;
  }

  & > div > span {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  & > div > span:first-of-type {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
`;

export const Separator = styled.div`
  height: auto;
  flex: 1;
  border-bottom: 1px solid ${({ theme }) => theme.palette.common.BACKGROUND_3};
`;

export const EmailInput = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 8px;
`;

export const ArrowCTA = styled(Button)`
  align-self: flex-start;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  height: 40px;
  min-width: 40px;
`;

export const FormInputContainer = styled(FInputContainer)`
  flex: 1;
  margin-bottom: 0;

  & input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    height: 40px;
    font-size: 14px;
    line-height: 16px;
    flex-grow: 3;
  }
`;

export const SuccessMessage = styled.span`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text};

  span:nth-child(2) {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  }

  & > span::before {
    margin-right: 8px;
  }
`;
